<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-10 11:22:22
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_List_Selections\selectValue.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-10 15:42:34
-->
<template>
  <normalDialog
    :dialog="show"
    width="800"
    :persistent="false"
    :show_title="false"
    maxWidth="800"
    height="800"
    pad="0"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-container
        fluid
        class="d-flex flex-wrap justify-center ma-0 pa-0 mx-auto"
        style="min-height: 400px"
      >
        <v-data-iterator
          :items="object.selected ? object.selected : []"
          :items-per-page.sync="itemsPerPage"
          :page.sync="page"
          hide-default-footer
          class="max-width d-flex flex-column"
          :footer-props="{
            'items-per-page-options': [10, 20, 50],
            'items-per-page-text': $t(
              'label_essweb_list_components_pagenations_perpageLabel'
            ),
          }"
        >
          <template v-slot:no-data>
            <v-skeleton-loader
              ref="skeleton"
              :loading="Loading"
              :boilerplate="false"
              type="table-cell"
              class="mx-auto"
            >
              <noContent />
            </v-skeleton-loader>
          </template>
          <template v-slot:default="props">
            <v-row justify="start" class="ma-3">
              <v-col
                v-for="(item, index) in props.items"
                :key="`item---${index}`"
                cols="12"
                sm="2"
                md="3"
                lg="4"
              >
                <v-hover v-slot="{ hover }">
                  <v-skeleton-loader
                    ref="skeleton"
                    :loading="Loading"
                    :boilerplate="false"
                    type="table-cell"
                    :height="64"
                    transition="scale-transition"
                    origin="center center"
                    class="mx-auto"
                  >
                    <v-card
                      elevation="0"
                      :class="hover ? 'mrc-grey' : 'white'"
                      class="rounded-pill"
                    >
                      <v-list-item class="px-2" dense>
                        <v-list-item-avatar v-if="object.avatar">
                          <StaffAvatar
                            left
                            contentClass="white--text"
                            :isTemp="item.is_temp"
                            :src="item.staff_avatar"
                            :staff_name="item[showKey]"
                          />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $getCommonLangValue(item[showKey]) }}
                            <span
                              class="text--secondary text-caption-xs"
                              v-if="
                                (type == 'select' && datatype == 'all_staff') ||
                                (type == 'select' && datatype == 'staff')
                              "
                              >{{ item[selectKey] }}</span
                            >
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="object.twoLine">
                            {{
                              $getCommonLangValue(
                                item[subKey] ? item[subKey] : ""
                              )
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="my-0">
                          <v-btn
                            icon
                            v-if="hover"
                            @click.stop="select(item)"
                            color="grey"
                            :ripple="false"
                            small
                          >
                            <span
                              class="material-icons-round md-18 text--secondary"
                              >cancel</span
                            >
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card>
                  </v-skeleton-loader>
                </v-hover>
              </v-col>
            </v-row>
          </template>
          <template v-slot:footer="props" v-if="showFooter">
            <v-spacer></v-spacer>
            <Pagenations
              v-if="
                object.selected &&
                object.selected.length &&
                object.selected.length > itemsPerPage
              "
              dense
              :options="props"
              :filterpage="page"
              :show-item-pages="false"
              :filterItemsPerPage="itemsPerPage"
              @change="onChange"
              :items="object.selected ? object.selected : []"
            />
          </template>
        </v-data-iterator>
      </v-container>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SelectValue",
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    ...mapGetters(["companyLang", "isLoading"]),
    type() {
      return this.object ? this.object["type"] : undefined;
    },
    subKey() {
      if (this.object && this.object["subKey"]) return this.object["subKey"];
      else {
        let data = this.object["data"];
        if (this.object && this.object["type"] == "select" && data) {
          return data["modelKey"] ? data["modelKey"] : "uuid";
        } else return "uuid";
      }
    },
    showKey() {
      if (this.object && this.object["showKey"]) return this.object["showKey"];
      else {
        let data = this.object["data"];
        if (this.object && this.object["type"] == "select" && data) {
          return data["modelKey"] ? data["modelKey"] : "uuid";
        } else return "uuid";
      }
    },
    valueKey() {
      let data = this.object["data"];
      if (this.object && this.object["type"] == "select" && data) {
        return data["valueKey"] ? data["valueKey"] : "uuid";
      } else return "uuid";
    },
    selectKey() {
      let data = this.object["data"];
      if (this.object && this.object["type"] == "select" && data) {
        return data["modelKey"] ? data["modelKey"] : "uuid";
      } else return "uuid";
    },
    datatype() {
      if (
        this.object &&
        this.object["data"] &&
        this.object["type"] == "select"
      ) {
        return this.object["data"]["url_type"];
      } else return undefined;
    },
  },
  props: {
    value: { default: "", type: [Number, String, Array] },
    object: { default: undefined, type: [Object] },
    avPerPage: { default: 18, type: [Number, String] },
    showFooter: { default: true, type: Boolean },
    show: { default: false, type: [Boolean, Number] },
  },
  data() {
    return { curValue: [], page: 1, itemsPerPage: 0, Loading: false };
  },
  watch: {
    value(val) {
      this.curValue = val;
    },
    curValue(val) {
      this.$emit("change", val);
    },
  },
  mounted() {
    this.itemsPerPage = this.avPerPage ? this.avPerPage : 18;
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    select(item) {
      this.$emit("select", item[this.valueKey], item);
    },
    onChange: function (page, perPage) {
      const that = this;
      this.Loading = true;
      that.$Sleep(1000).then(() => {
        if (page !== undefined) that.page = page;
        if (perPage !== undefined) that.itemsPerPage = perPage;
        that.Loading = false;
      });
    },
  },
};
</script>